import React from 'react';

import { ShowOnMQ } from 'core/modules/MediaQueries/MediaQueries';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import './MemberSection.scss';

function MemberSection() {
  const { acquisitionMembersCount } = window;

  return (
    <div className="mn_memberSection">
      <ContentWrap>
        <SectionTitle title={`${acquisitionMembersCount} members are earning miles\u2014and loving it`} />
        <p>Don't leave your miles behind. Start earning today.</p>
        <ShowOnMQ tablet desktop>
          <div className="mn_testimonials">
            <div className="mn_testimonial">
              <blockquote className="mn_quote">
                "I love being able to earn miles for shopping.  It's so easy to use and I love the bonus offers, too."
              </blockquote>
              <span className="mn_author">Regina C.</span>
            </div>
            <div className="mn_testimonial">
              <blockquote className="mn_quote">
                "I like getting miles for purchases I'm already making. Plus, it's an extra incentive
                for making other purchases on participating websites."
              </blockquote>
              <span className="mn_author">Robert N.</span>
            </div>
            <div className="mn_testimonial">
              <blockquote className="mn_quote">
                "MileagePlus Shopping is so easy to use and a very good way to accumulate miles."
              </blockquote>
              <span className="mn_author">Joanne F.</span>
            </div>
          </div>
        </ShowOnMQ>
      </ContentWrap>
    </div>
  );
}

export default MemberSection;
